"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefinitionListTerm = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const react_1 = __importDefault(require("react"));
const StyledDefinitionTerm = components_core_1.styled.dt `
  display: inline;
  font-weight: bold;

  :before {
    content: '\u00a0• ';
  }

  :first-child {
    :before {
      content: none;
    }
  }
`;
function DefinitionListTerm({ children }) {
    return (react_1.default.createElement(StyledDefinitionTerm, { className: "definition-list-term-container" },
        react_1.default.createElement(components_core_1.Text, { appearance: components_core_1.TokenTextAppearance.copy100, tag: components_core_1.TextTag.span, bold: true },
            children,
            ' ')));
}
exports.DefinitionListTerm = DefinitionListTerm;
